<template>
    <div v-if="sticker" class="w-100">
        <!--
        <v-row class="no-frame">
            <v-col class="no-frame" style="text-align: center">
                <v-select
                    v-if           = "items"
                    :items         = "items"
                    v-model        ="selected"
                    item-value     = "id"
                    item-text      = "name"
                    :return-object = true
                    @input         = "onQrCode"
                    hide-details
                    dense
                />
            </v-col>
        </v-row>
        -->

        <v-row class="no-frame mt-0">
            <v-col class="no-frame " style="text-align: left">
                <v-select
                    v-if           = "items"
                    :items         = "items"
                    v-model        ="selected"
                    item-value     = "id"
                    item-text      = "name"
                    :return-object = true
                    @input         = "onQrCode"
                    hide-details
                    dense
                />
                <div style="font-size: 9px; margin-top: 4px">
                    {{ selected ? selected.id : '---' }}
                </div>
            </v-col>
            <v-col class="no-frame ml-2 mt-n3" style="text-align: center">
                <canvas id="canvas" class="w-100"></canvas>
            </v-col>
        </v-row>
<!--
        <v-row class="no-frame mt-n1">
            <v-col class="no-frame" style="text-align: center; font-size: 14px;">
                {{ selected ? selected.id : '---' }}
            </v-col>
        </v-row>
        -->
    </div>
</template>

<script>
import qrcode from 'qrcode';

export default {
    name: "CUnitStickerList",
    components: {},

    props: {
        sticker: {
            type: Array,
            required: true
        }
    },

    data: () => ({
        qrcode: null,
        qrcodeCanvas: null,
        items: [],
        selected: null,
    }),

    mounted() {
        this.qrcodeCanvas = document.getElementById('canvas')
        this.qrcode = qrcode;
        this.initialize();
    },

    watch: {
        sticker () {
            this.initialize();
        }
    },

    methods: {
        initialize () {
            if (!this.sticker) {
                return;
            }

            this.sticker.forEach (sticker => {
                this.items.push ({
                    id: sticker.uuid,
                    name: this.floor (sticker)
                });
            });

            if (this.items.length > 0) {
                this.selected = this.items[0];
                this.onQrCode();
            }
        },

        onQrCode () {
            if (!this.selected) {
                return;
            }

            this.qrcode.toCanvas(this.qrcodeCanvas, "https://liftmanager.io/home/" + this.selected.id, {width: 150}, function (error) {
                console.log(error);
            })
        },

        floor (item) {
            switch (item.type) {
                case "CAR"  : return "Fahrkorb";
                case "SHAFT": return "Schacht";
                case "FLOOR": return "Level " + item.floor;
                default: return null;
            }
        }
    }
}
</script>

<style scoped>

.sticker-uuid {
    font-size: 14px;
}

</style>